import { useMemo } from "react";
import { useSelector } from "react-redux";

const useSelectedAppTypes = () => {
  const apps = useSelector((state) => state.apps.apps);
  const appType = useSelector((store) => store.dashboardFilters.appType);

  return useMemo(() => {
    return (apps || []).filter((app) => (appType || []).some((type) => type.id === app.appType));
  }, [apps, appType]);
};

export default useSelectedAppTypes;
